import { useParsed } from '@refinedev/core'
import { useTranslation } from 'react-i18next'
import { EditView, EditViewHeader } from '~/components/refineUi/views/editView'
import { LocationForm } from './form'

export function LocationEdit() {
  const { t } = useTranslation()
  const { id } = useParsed()
  return (
    <EditView>
      <EditViewHeader title={t('locationsPage.edit.title')} />
      <LocationForm
        action="edit"
        id={String(id)}
      />
    </EditView>
  )
}
